<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="阈值自动控制" name="first">
        <div style="background-color: white; padding: 15px 0 15px 20px; text-align: left;">
          <div>
            <span>选择生产单元：</span>
            <el-select v-model="checkedCell" placeholder="请选择生产单元" style="border:1px solid #dcdfe6; width: 300px; border-radius: 4px; margin-right: 20px;">
              <el-option
                v-for="cell in listCell"
                :key="cell.id"
                :label="cell.name"
                :value="cell.id">
              </el-option>
            </el-select>
            <el-button type="primary" @click="getYuLog()">确定</el-button>
            <el-button type="primary" @click="add_yuzhi = true">新增</el-button>
          </div>
        </div>
        <div style="background-color: white; margin-top: 20px;">
          <el-table
            :data="listYuzhi"
          >
            <el-table-column prop="num" label="序号"></el-table-column>
            <el-table-column prop="param" label="被控环境参数"></el-table-column>
            <el-table-column prop="actup" label="操作上限"></el-table-column>
            <el-table-column prop="actdw" label="操作下限"></el-table-column>
            <el-table-column prop="wnup" label="告警上限"></el-table-column>
            <el-table-column prop="wndw" label="告警下限"></el-table-column>
            <el-table-column prop="autofg" label="启用标识"></el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="chg_yuzhi(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="sensor_del cell_chg_cel cell_del" @click="del_yuzhi(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="时间自动控制" name="second">
        <div style="background-color: white; padding: 15px 0 15px 20px; text-align: left;">
          <div>
            <span>选择生产单元：</span>
            <el-select v-model="checkedCell1" placeholder="请选择生产单元" style="border:1px solid #dcdfe6; width: 300px; border-radius: 4px; margin-right: 20px;">
              <el-option
                v-for="cell in listCell1"
                :key="cell.id"
                :label="cell.name"
                :value="cell.id">
              </el-option>
            </el-select>
            <el-button type="primary" @click="getTimeLog()">确定</el-button>
            <el-button type="primary" @click="add_time = true">新增</el-button>
          </div>
        </div>
        <div style="background-color: white; margin-top: 20px;">
          <el-table
            :data="listTimeLog"
          >
            <el-table-column prop="num" label="序号"></el-table-column>
            <el-table-column prop="param" label="被控环境参数"></el-table-column>
            <el-table-column prop="time" label="动作时间点"></el-table-column>
            <el-table-column prop="opt" label="执行动作"></el-table-column>
            <el-table-column prop="autofg" label="启用标识"></el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="chg_time(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="sensor_del cell_chg_cel cell_del" @click="del_time(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="change_yuzhi">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="form" label-width="120px" class="demo-ruleForm">
            <el-form-item label="被控环境参数：">
              <el-select v-model="form.env_type" placeholder="请选择环境参数" style="width: 380px">
                <div v-for="(param,index) in cell_params" :key="index">
                  <el-option :label="param.type" :value="param.type"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="告警上限：">
              <el-input v-model="form.wnup" placeholder="自定义" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item label="告警下限：">
              <el-input v-model="form.wndw" placeholder="自定义" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item label="操作上限：">
              <el-input v-model="form.actup" placeholder="自定义" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item label="操作下限：">
              <el-input v-model="form.actdw" placeholder="自定义" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item label="启用标识：">
              <el-select v-model="form.autofg" placeholder="请选择是否启用"  style="width: 380px">
                <div v-for="(autofg,index) in autofg" :key="index">
                  <el-option :label="autofg.label" :value="autofg.value"></el-option>
                </div>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="change_yuzhi = false">取 消</el-button>
        <el-button type="primary" @click="pre_yuzhi">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="change_time">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="formTime" label-width="120px" class="demo-ruleForm">
            <el-form-item label="被控环境参数：">
              <el-select v-model="formTime.env_type" placeholder="请选择环境参数" style="width: 380px">
                <div v-for="(param,index) in time_cell_params" :key="index">
                  <el-option :label="param" :value="param"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="动作时间点：">
              <el-input v-model="formTime.time" placeholder="自定义" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item label="执行动作：">
              <el-select v-model="formTime.opt" placeholder="请选择是否打开/关闭"  style="width: 380px">
                <div v-for="(opt,index) in opt" :key="index">
                  <el-option :label="opt.label" :value="opt.value"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="启用标识：">
              <el-select v-model="formTime.autofg" placeholder="请选择是否启用"  style="width: 380px">
                <div v-for="(autofg,index) in autofg" :key="index">
                  <el-option :label="autofg.label" :value="autofg.value"></el-option>
                </div>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="change_time = false">取 消</el-button>
        <el-button type="primary" @click="pre_time">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="add_yuzhi">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="formAddYuzhi" label-width="120px" class="demo-ruleForm">
            <el-form-item label="生产单元：">
              <el-select v-model="formAddYuzhi.cell_id" placeholder="请选择生产单元" style="width: 380px">
                <div v-for="(cell,index) in listCell" :key="index">
                  <el-option :label="cell.name" :value="cell.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="被控环境参数：">
              <el-select v-model="formAddYuzhi.env_type" placeholder="请选择环境参数" style="width: 380px">
                <div v-for="(param,index) in cell_params" :key="index">
                  <el-option :label="param.type" :value="param.type"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="启用标识：">
              <el-select v-model="formAddYuzhi.autofg" placeholder="请选择是否启用"  style="width: 380px">
                <div v-for="(autofg,index) in autofg" :key="index">
                  <el-option :label="autofg.label" :value="autofg.value"></el-option>
                </div>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="add_yuzhi = false">取 消</el-button>
        <el-button type="primary" @click="addYuLog">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="add_time">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="formAddTime" label-width="120px" class="demo-ruleForm">
            <el-form-item label="生产单元：">
              <el-select v-model="formAddTime.cell_id" placeholder="请选择生产单元" style="width: 380px">
                <div v-for="(cell,index) in listCell" :key="index">
                  <el-option :label="cell.name" :value="cell.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="被控环境参数：">
              <el-select v-model="formAddTime.env_type" placeholder="请选择环境参数" style="width: 380px">
                <div v-for="(param,index) in time_cell_params" :key="index">
                  <el-option :label="param" :value="param"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="动作时间点：">
              <el-input v-model="formAddTime.time" placeholder="00:00:00" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item label="执行动作：">
              <el-select v-model="formAddTime.opt" placeholder="请选择是否打开/关闭"  style="width: 380px">
                <div v-for="(opt,index) in opt" :key="index">
                  <el-option :label="opt.label" :value="opt.value"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="启用标识：">
              <el-select v-model="formAddTime.autofg" placeholder="请选择是否启用"  style="width: 380px">
                <div v-for="(autofg,index) in autofg" :key="index">
                  <el-option :label="autofg.label" :value="autofg.value"></el-option>
                </div>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="add_time = false">取 消</el-button>
        <el-button type="primary" @click="addTimeLog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      checkedCell: '',
      checkedCell1: '',
      listCell: [],
      listCell1: [],
      listYuzhi: [],
      listTimeLog: [],
      cell_params: [],
      time_cell_params: [],
      change_yuzhi: false,
      change_time: false,
      add_yuzhi: false,
      add_time: false,
      autofg: [{value: '1', label: '启用'}, {value: '0', label: '不启用'}],
      opt: [{value: '1', label: '打开'}, {value: '0', label: '关闭'}],
      form: {
        id: '',
        env_type: '',
        param_id: '',
        wnup: '',
        wndw: '',
        actup: '',
        actdw: '',
        autofg: ''
      },
      formTime: {
        id: '',
        env_type: '',
        time: '',
        opt: '',
        autofg: ''
      },
      formAddYuzhi: {
        cell_id: '',
        env_type: '',
        param_id: '',
        autofg: ''
      },
      formAddTime: {
        cell_id: '',
        env_type: '',
        time: '',
        opt: '',
        autofg: ''
      }
    }
  },
  methods: {
    getAllCell () {
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listCell = res.data.data.list
        this.listCell1 = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    // 查询
    getYuLog () {
      this.axios.get(this.$store.state.ip + 'envctldef/lstThCtlParam',
        {
          params: {'cell_id': this.checkedCell},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listYuzhi = res.data.data
        for (let i = 0; i < this.listYuzhi.length; i++) {
          this.listYuzhi[i].num = i + 1
          if (this.listYuzhi[i].autofg === 0) {
            this.listYuzhi[i].autofg = '不启用'
          } else {
            this.listYuzhi[i].autofg = '启用'
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 查询
    getTimeLog () {
      this.axios.get(this.$store.state.ip + 'envctldef/lstTmCtlParam',
        {
          params: {'cell_id': this.checkedCell1},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listTimeLog = res.data.data
        for (let i = 0; i < this.listTimeLog.length; i++) {
          this.listTimeLog[i].num = i + 1
          if (this.listTimeLog[i].opt === 0) {
            this.listTimeLog[i].opt = '关闭'
          } else {
            this.listTimeLog[i].opt = '开启'
          }
          if (this.listTimeLog[i].autofg === 0) {
            this.listTimeLog[i].autofg = '不启用'
          } else {
            this.listTimeLog[i].autofg = '启用'
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 新增
    addYuLog () {
      for (let i = 0; i < this.cell_params.length; i++) {
        if (this.cell_params[i].type === this.formAddYuzhi.env_type) {
          this.formAddYuzhi.param_id = this.cell_params[i].snpid
          break
        }
      }
      let formdata = new FormData()
      formdata.append('cell_id', this.formAddYuzhi.cell_id)
      formdata.append('env_type', this.formAddYuzhi.env_type)
      formdata.append('param_id', this.formAddYuzhi.param_id)
      formdata.append('auto_fg', this.formAddYuzhi.autofg)
      this.axios.post(this.$store.state.ip + 'envctldef/addThCtl', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('增加成功')
      }).catch(err => {
        console.log(err)
        this.$message.success('增加失败')
      })
      this.add_yuzhi = false
    },
    // 新增
    addTimeLog () {
      let formdata = new FormData()
      formdata.append('cell_id', this.formAddTime.cell_id)
      formdata.append('env_type', this.formAddTime.env_type)
      formdata.append('time', this.formAddTime.time)
      formdata.append('opt', this.formAddTime.opt)
      formdata.append('auto_fg', this.formAddTime.autofg)
      this.axios.post(this.$store.state.ip + 'envctldef/addTmCtl', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('增加成功')
      }).catch(err => {
        console.log(err)
        this.$message.success('增加失败')
      })
      this.add_time = false
    },
    chg_yuzhi (row) {
      this.change_yuzhi = true
      this.cellParams(row.cellid)
      this.form.id = row.id
      this.form.env_type = row.param
      this.form.param_id = row.param_id
      this.form.wnup = row.wnup
      this.form.wndw = row.wndw
      this.form.actup = row.actup
      this.form.actdw = row.actdw
      if (row.autofg === '不启用') {
        this.form.autofg = '0'
      } else {
        this.form.autofg = '1'
      }
    },
    pre_yuzhi () {
      for (let i = 0; i < this.cell_params.length; i++) {
        if (this.cell_params[i].type === this.form.env_type) {
          this.form.param_id = this.cell_params[i].snpid
          break
        }
      }
      let formdata = new FormData()
      formdata.append('id', this.form.id)
      formdata.append('env_type', this.form.env_type)
      formdata.append('param_id', this.form.param_id)
      formdata.append('wnup', this.form.wnup)
      formdata.append('wndw', this.form.wndw)
      formdata.append('actup', this.form.actup)
      formdata.append('actdw', this.form.actdw)
      formdata.append('autofg', this.form.autofg)
      this.axios.post(this.$store.state.ip + 'envctldef/updateThCtl', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('修改成功')
        this.getYuLog()
      }).catch(err => {
        console.log(err)
        this.$message.success('修改失败')
      })
      this.change_yuzhi = false
    },
    chg_time (row) {
      this.change_time = true
      this.timeCellParams(row.cellid)
      this.formTime.id = row.id
      this.formTime.env_type = row.param
      this.formTime.time = row.time
      this.formTime.opt = '1'
      if (row.opt === '关闭') {
        this.formTime.opt = '0'
      }
      this.formTime.autofg = '1'
      if (row.autofg === '不启用') {
        this.formTime.autofg = '0'
      }
    },
    pre_time () {
      let formdata = new FormData()
      formdata.append('id', this.formTime.id)
      formdata.append('env_type', this.formTime.env_type)
      formdata.append('time', this.formTime.time)
      formdata.append('opt', this.formTime.opt)
      formdata.append('autofg', this.formTime.autofg)
      this.axios.post(this.$store.state.ip + 'envctldef/updateTmCtl', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('修改成功')
        this.getTimeLog()
      }).catch(err => {
        console.log(err)
        this.$message.success('修改失败')
      })
      this.change_time = false
    },
    // 删除
    del_yuzhi (row) {
      this.$confirm('此操作将永久删除该自动管理控制, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(this.$store.state.ip + 'envctldef/delThCtl',
          {
            params: {'id': row.id},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getYuLog()
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info'
        })
      })
    },
    del_time (row) {
      this.$confirm('此操作将永久删除该自动管理控制, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(this.$store.state.ip + 'envctldef/delTmCtl',
          {
            params: {'id': row.id},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getTimeLog()
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info'
        })
      })
    },
    // 环境采集参数
    cellParams (cellid) {
      this.axios.get(this.$store.state.ip + 'sensordef/cellParams',
        {
          params: {'cell_id': cellid},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.cell_params = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    // 环境采集参数
    timeCellParams (cellid) {
      this.axios.get(this.$store.state.ip + 'equipdef/listCtrlEnrv',
        {
          params: {'cell_id': cellid},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.time_cell_params = res.data.data
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.getAllCell()
  },
  watch: {
    'formAddYuzhi.cell_id': function () {
      this.cellParams(this.formAddYuzhi.cell_id)
    },
    'formAddTime.cell_id': function () {
      this.timeCellParams(this.formAddTime.cell_id)
    }
  }
}
</script>

<style scoped>
  .sensor_del {
    font-weight: normal;
  }
  .cell_del{
    color: #F56C6C;
    margin-left: 5px;
  }
  .cell_chg_cel {
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
  }
  .addSensor_form {
    width: 400px;
    margin-left: 20px;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/userData/Automatic.vue